@if (showQuestionAlertDialog || showTimeDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full flex justify-center items-center">
      <div class="items-center justify-center rounded-[16px] bg-white p-3 absolute">
        @if (showQuestionAlertDialog) {
          <div class="max-w-[350px]">
            <div class="mb-2 font-bold text-center">
              Sure you want to submit?
            </div>
            @if (showQuestionAlertDialog) {
              <div class="text-sm text-center">
                NOTE: One or more of your questions for this part has not had their answers recorded
              </div>
            }
            <div class="flex justify-between mt-4">
              <outline-button [marginRight]="true" (click)="showQuestionAlertDialog = false" text="Cancel"/>
              <full-button (click)="forceSubmit()" text="Submit" [disabled]="disableSubmitButton" />
            </div>
          </div>
        }
        @if (showTimeDialog) {
          <div class="max-w-[350px] text-zinc-6npm 00 text-center">
            <div class="flex justify-end">
              <button aria-label="Show Time Dialog" (click)="showTimeDialog = false" class="hover:bg-gray-100 rounded-full p-0.5 w-8 h-8 ml-1">
                <fa-icon [icon]="faXmark" />
              </button>
            </div>
            <div class="mb-2 font-bold">
              Disclaimer about exam timer
            </div>
            <div class="mb-2">
              The exam timer is an <b>estimation</b> of the remaining time. If timer shows zero you are still able to take and submit your exam part. It will be marked as late.
              <br/>
              Please contact your professor or the system admin to review your exam instance.
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
<div id="top"></div>
<div class="flex items-center justify-between px-4">
  <div class="text-2xl mt-8 ml-5 mb-3 flex gap-2">
    @if (examResponse != null) {
      <div>
        <b>{{examResponse.details.exam_title}}</b> - {{examResponse.parts[display_part].details.part_name}}
      </div>
    }
    @if (examResponse == null) {
      <div class="bg-gray-200 animate-pulse h-[30px] w-[50%] rounded-full"></div>
    }
    @if (isLoading) {
      <dot-spinner />
    }
  </div>
  @if(!isClassroom) {
    <outline-button (click)="exitExam()" text="Exit Exam" />
  } @else {
    <outline-button (click)="exitAssessment()" text="Exit" />
  }
</div>
<hr/>
@if (instructions || showPartInstructions) {
  <div class="grid grid-cols-3 my-3 ml-8">
    <!--<div class="flex items-center">
      <b class="mr-2">Due: </b>
      @if (examResponse != null) {
        <span>
          @if (examResponse.parts[part] != null) {
            <span>
              {{examResponse.parts[part].due_time | date: 'short'}}
            </span>
          }
          @if (examResponse.parts[part] == null) {
            <span>
              {{examResponse.due_time | date: 'short'}}
            </span>
          }
        </span>
      }
      @if (examResponse == null) {
        <div class="bg-gray-200 animate-pulse h-[20px] w-[150px] rounded-full"></div>
      }
    </div>-->
    <div class="flex items-center">
      <b class="mr-2">Questions: </b>
      @if (examResponse != null && Array.isArray(examResponse.parts[display_part].questions) && examResponse.parts[display_part].questions.length > 0) {
        <span>
          {{examResponse.parts[display_part].questions.length}}
        </span>
      } @else if (examResponse != null) {
        <span>
          {{examResponse.parts[display_part].details.questions_total}}
        </span>
      }
      @if (examResponse == null) {
        <div class="bg-gray-200 animate-pulse h-[20px] w-[20px] rounded-full"></div>
      }
    </div>
    <div class="flex items-center">
      <b class="mr-2">Time Limit: </b>
      @if (examResponse != null) {
        <span>
          @if (examResponse.parts[display_part].details.part_duration_minutes != null) {
            <span>
              {{examResponse.parts[display_part].details.part_duration_minutes}} minute(s)
            </span>
          }
          @if (examResponse.parts[display_part].details.part_duration_minutes == null) {
            <span>
              No Limit
            </span>
          }
        </span>
      }
      @if (examResponse == null) {
        <div class="bg-gray-200 animate-pulse h-[20px] w-[80px] rounded-full"></div>
      }
    </div>
    <div class="flex items-center">
      <b class="mr-2">Allowed Attempts: </b>
      @if (examResponse != null) {
        <span>
          {{examResponse.details.attempts_max}}
        </span>
      }
      @if (examResponse == null) {
        <div class="bg-gray-200 animate-pulse h-[20px] w-[20px] rounded-full"></div>
      }
    </div>
  </div>
}
<hr />
@if (instructions || showPartInstructions) {
  <div class="m-5 flex flex-col">
    <div class="text-xl font-bold flex-none">
      Instructions
    </div>
    <div class="flex-grow border border-black rounded-md p-3 mt-3">
      @if (examResponse != null) {
        <div class="min-w-0 w-full max-w-full overflow-hidden break-words [&_*]:max-w-full [&_*]:[overflow-wrap:anywhere] [&_code]:whitespace-pre-wrap [&_img]:max-w-full [&_p]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:mb-1 [&_a]:text-blue-600 [&_a]:underline [&_a:hover]:text-blue-800">
          @if (examResponse.parts[display_part].details.part_instructions) {
            <div class="w-full max-w-full whitespace-pre-wrap" [innerHTML]="formatInstructions(examResponse.parts[display_part].details.part_instructions)"></div>
          }
        </div>
      }
    </div>
    <div class="flex flex-initial justify-center my-6">
      @if (instructions && !isPreview) {
        <full-button [text]="isClassroom? 'Continue':'Continue Exam'" (click)="takeExam(part_position === 0 && !resume)"/>
      }
      @if (isPreview) {
        <full-button [text]="isClassroom? 'Continue':'Continue Exam'" (click)="nextPart()" />
      }
    </div>
  </div>
}
@if (!instructions && !showPartInstructions) {
  <div class="flex flex-col">
    <div class="flex flex-grow">
      <div class="flex flex-col flex-grow">
        @if (examResponse != null) {
          <div class="flex justify-between items-center mx-11 pt-6 pb-4">
            <b>
              Question {{question+1}}
            </b>
            <!--<div class="text-center flex-shrink">
              &lt;!&ndash; TODO time left isn't possible atm &ndash;&gt;
              <b>Due date: </b>
              @if (this.examResponse != null) {
                <span>
                  {{this.examResponse.parts[part].due_time | date: 'short'}}
                </span>
              }
            </div>-->
            @if (examResponse.parts[part].details.part_duration_minutes != null) {
              <div>
                <span [ngClass]="!hideCountdown? 'text-black':'text-transparent select-none'">
                  <!-- TODO removed this disclaimer since it is no longer true, need to rewrite it -->
                  <!--<button aria-label="Open Time Details" (click)="openTimeDetail()" class="mr-1">
                    <fa-icon [ngClass]="!hideCountdown? 'text-slate-500 text-sm':'text-transparent text-sm select-none'" [icon]="faCircleInfo" />
                  </button>-->
                  <b>Time Remaining: </b>
                  @if (examResponse.parts[part].details.part_duration_minutes != null) {
                    <countdown [config]="countdownConfig" (event)="handleCountdownEvent($event)" />
                  }
                </span>
                <button (click)="hideCountdown = !hideCountdown" class="text-sm text-slate-500 ml-1">
                  @if (hideCountdown) {
                    <fa-icon [icon]="faEye" tooltip="Show Timer" tooltipPosition="below" />
                  }
                  @if (!hideCountdown) {
                    <fa-icon [icon]="faEyeSlash" tooltip="Hide Timer" tooltipPosition="below" />
                  }
                </button>
              </div>
            }
          </div>
        }
        <div class="flex flex-col justify-between flex-grow border border-black rounded-[8px] p-3 mt-3 mx-10">
          @if (isLoading) {
            <div>
              <div class="animate-pulse bg-gray-200 h-[24px] w-[80%] m-2 rounded-full"></div>
              <div class="animate-pulse bg-gray-200 h-[24px] w-[60%] m-2 rounded-full"></div>
              <div class="animate-pulse bg-gray-200 h-[24px] w-[70%] m-2 rounded-full"></div>
            </div>
          }
          @if (examResponse != null) {
            <div>
              @if (examResponse.parts[part] != null) {
                <div>
                  @if (examResponse.parts[part].questions[question] != null) {
                    @if (showSurveyWarning && !isPreview) {
                      <div class="flex items-center gap-2 bg-amber-50 border border-amber-300 rounded-md px-4 py-3 mt-2 mb-4">
                        <span class="text-amber-500 mt-0.5"><fa-icon class="ml-1" [icon]="faTriangleExclamation"/> </span>
                        <p class="text-amber-800 text-sm">Please answer this survey question before you proceed. Unanswered survey questions may affect placement accuracy.</p>
                      </div>
                    }
                    <div>
                      @if(isLoading) {
                        <div class="mb-6 h-[24px] w-[450px] bg-gray-200 rounded-[6px] animate-pulse"></div>
                      }
                      @if (examResponse.parts[part].questions[question].question.mathjax) {
                        <p [mathjax]="examResponse.parts[part].questions[question].question.question_text" class="mb-6"></p>
                      }
                      @if (!examResponse.parts[part].questions[question].question.mathjax) {
                        <p [innerHTML]="examResponse.parts[part].questions[question].question.question_text" class="mb-6"></p>
                      }
                      @if (examResponse.parts[part].questions[question].question.audio != null) {
                        <div>
                          @for (audio of examResponse.parts[part].questions[question].question.audio; track audio) {
                            <div class="mt-2">
                              <audio-playback [audio_url]="audio.source"/>
                            </div>
                          }
                        </div>
                      }
                      @if (examResponse.parts[part].questions[question].question.type === 'MULTIPLECHOICE') {
                        <div>
                          <multiple-choice
                            (onSelectEmitter)="recordAnswerText(examResponse.parts[part].questions[question].question.recordedAnswer)"
                            [problem_template]="examResponse.parts[part].questions[question].question"
                            [(recordedAnswer)]="examResponse.parts[part].questions[question].question.recordedAnswer"
                            [review]="isPreview"
                          />
                        </div>
                      }
                      @if (examResponse.parts[part].questions[question].question.type === 'DECIMAL' || examResponse.parts[part].questions[question].question.type === 'INTEGER') {
                        <div>
                          <decimal
                            (onChangeEmitter)="recordAnswer(examResponse.parts[part].questions[question].question.recordedAnswer)"
                            [(answer)]="examResponse.parts[part].questions[question].question.recordedAnswer"
                          />
                        </div>
                      }
                      @if (examResponse.parts[part].questions[question].question.type === 'TEXTAREA' || examResponse.parts[part].questions[question].question.type === 'REGEX') {
                        <div>
                          <text-area
                            [(answer)]="examResponse.parts[part].questions[question].question.recordedAnswer"
                            (onChangeEmitter)="recordAnswerText(examResponse.parts[part].questions[question].question.recordedAnswer)"
                          />
                        </div>
                      }
                      @if (examResponse.parts[part].questions[question].question.type === 'MULTIFIELD' || examResponse.parts[part].questions[question].question.type === 'PASSAGE') {
                        <div>
                          <multifield
                            [problem_template]="examResponse.parts[part].questions[question].question"
                            (onChangeEmitter)="recordAnswerText(tempClusterJSON)"
                            [(answer)]="tempClusterJSON"
                            [review]="isPreview"
                          />
                        </div>
                      }
                      @if (examResponse.parts[part].questions[question].question.type === 'FORMULA') {
                        <div>
                          <formula />
                        </div>
                      }
                      @if (examResponse.parts[part].questions[question].question.type === 'RECORD_AUDIO') {
                        <div class="flex flex-col items-center">
                          <audio-record
                            [problem_template]="examResponse.parts[part].questions[question].question"
                            [(answer)]="examResponse.parts[part].questions[question].question.recordedAnswer"
                            (answerChange)="uploadAudioRecord($event)"
                            />
                            <audio-playback [audio_url]="examResponse.parts[part].questions[question].question.recordedAnswer || ''"></audio-playback>
                          </div>
                        }
                        @if (examResponse.parts[part].questions[question].question.type === 'UPLOAD_DOC') {
                          <div>
                            <file-upload
                              [(answer)]="examResponse.parts[part].questions[question].question.recordedAnswer"
                              (answerChange)="uploadFileRecord($event)"
                              [file_extensions]="examResponse.parts[part].questions[question].question.upload_extensions || []"
                              />
                              @if (examResponse.parts[part].questions[question].question.type === 'UPLOAD_DOC' && examResponse.parts[part].questions[question].question.recordedAnswer !== null) {
                                <div class="mt-2">
                                  <a [href]="examResponse.parts[part].questions[question].question.recordedAnswer" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">
                                    View Uploaded File
                                  </a>
                                </div>
                              }
                            </div>
                          }
                          @if (examResponse.parts[part].questions[question].question.type === 'GROUPING') {
                            <div>
                              <grouping
                                [problem_template]="examResponse.parts[part].questions[question].question"
                                [(answer)]="examResponse.parts[part].questions[question].question.recordedAnswer"
                                (onChangeEmitter)="recordAnswer(examResponse.parts[part].questions[question].question.recordedAnswer)"
                              />
                            </div>
                          }
                          @if (examResponse.parts[part].questions[question].question.type === 'PROGRAMMING') {
                            <div>
                              <code-editor
                                [answerSkeleton]="examResponse.parts[part].questions[question].question.answerSkeleton"
                                [recordedAnswer]="examResponse.parts[part].questions[question].question.recordedAnswer"
                                [sampleCases]="examResponse.parts[part].questions[question].question.sampleCases"
                                [(samplesRemaining)]="examResponse.parts[part].questions[question].question.samplesRemaining"
                                [exam_uuid]="examUUID"
                                [part_position]="part_position"
                                [argumentNames]="examResponse.parts[part].questions[question].question.argumentNames"
                                [question_position]="question_position"
                                [(code)]="examResponse.parts[part].questions[question].question.recordedAnswer"
                                (onChangeEmitter)="recordAnswer(examResponse.parts[part].questions[question].question.recordedAnswer)"
                                />
                              </div>
                            }
                            <!-- TODO do the other question types and implement answer submit onChange -->
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <div class="flex flex-shrink justify-between mt-6">
                  <outline-button [marginRight]="true" [faIcon]="faArrowLeft" (click)="prevQuestion()" text="Previous" [disabled]="question === 0" />
                  <outline-button (click)="nextQuestion()" text="Next" [faIcon]="faArrowRight" [IconRight]="true" [disabled]="question === questionMenu.length - 1 || showSurveyWarning"/>
                </div>
              </div>
              <div class="flex justify-center items-center my-6">
                <full-button (click)="submitPart()" text="Submit" [disabled]="disableSubmitButton || partHasUnansweredSurveyQuestions()" />
              </div>
            </div>
            <div class="flex-shrink mt-3 mr-10 overflow-x-hidden justify-items-center text-center min-w-fit">
              <b class="mb-1">Question Menu</b>
              <div class="flex-1 overflow-y-auto overflow-x-hidden max-h-[400px]">
                @for (q of [].constructor(questionMenu.length); track q; let i = $index) {
                  <div class="flex mt-1 items-center">
                    @if (questionMenu[i].hasAnswer) {
                      <fa-icon class="text-[8px] text-neutral-600 mt-0.5 mr-1" [icon]="faCircle"/>
                    }
                    @if (!questionMenu[i].hasAnswer) {
                      <fa-icon class="text-[8px] invisible mt-0.5 mr-1" [icon]="faCircle"/>
                    }
                    <button (click)="tryNavigateToQuestion(i)" [ngClass]="i === question? 'flex flex-grow bg-neutral-500 text-white hover:bg-neutral-600 rounded-[4px] px-1': 'flex flex-grow hover:bg-gray-200 rounded-[4px] px-1'">
                      <div class="text-nowrap text-center">
                        Question {{i+1}}
                      </div>
                    </button>
                    <button (click)="toggleFlag(i)" class="flex-shrink px-1 rounded-[4px] hover:bg-gray-200 mx-1 text-xs">
                      @if (!questionMenu[i].flag) {
                        <fa-icon [icon]="faFlag" class="text-neutral-600"/>
                      }
                      @if (questionMenu[i].flag) {
                        <fa-icon [icon]="faFlag" class="text-orange-400"/>
                      }
                    </button>
                  </div>
                }
              </div>
              <!-- TODO do the other question types and implement answer submit onChange -->
            </div>
          </div>
        </div>
      }
